var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79099 9C10.4478 9 11.791 7.65685 11.791 6C11.791 4.34315 10.4478 3 8.79099 3C7.13414 3 5.79099 4.34315 5.79099 6C5.79099 7.65685 7.13414 9 8.79099 9Z",
    fill: "#DA6900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28345 10.6082C4.39971 10.8835 3.86362 11.776 4.03026 12.6865C4.25369 13.9073 4.52151 14.8854 4.78081 15.8324C5.00439 16.6489 5.22164 17.4423 5.39866 18.3483C5.59466 19.3514 6.44106 20.125 7.46316 20.125H9.34393C8.49882 18.9682 8 17.5423 8 16C8 13.6227 9.18504 11.5222 10.9966 10.257C9.03808 9.82208 7.43136 9.93914 5.28345 10.6082Z",
    fill: "#DA6900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9998 12.5359C13.4137 12.2969 13.7654 11.9382 13.8814 11.4745L14 11H16L16.119 11.4758C16.2348 11.9392 16.5831 12.2956 16.9972 12.5337C17.4113 12.7717 17.9003 12.8999 18.3595 12.7686L18.8299 12.634L19.8299 14.366L19.4782 14.7061C19.1348 15.0382 19.0013 15.5258 19.0004 16.0034C18.9996 16.4812 19.134 16.9611 19.4774 17.2931L19.8299 17.634L18.8299 19.366L18.3593 19.2314C17.8999 19.1 17.4136 19.2252 16.9998 19.4641C16.5861 19.7029 16.2346 20.0614 16.1188 20.5248L16 21H14L13.8812 20.5247C13.7653 20.0611 13.4168 19.7046 13.0025 19.4665C12.5884 19.2283 12.0992 19.1001 11.6399 19.2315L11.1697 19.366L10.1697 17.634L10.5213 17.294C10.8647 16.9619 10.9982 16.4742 10.9991 15.9966C11 15.5188 10.8655 15.0388 10.522 14.7067L10.1697 14.366L11.1697 12.634L11.6402 12.7686C12.0996 12.9 12.5859 12.7748 12.9998 12.5359ZM13.5858 14.5858C14.3668 13.8047 15.6332 13.8047 16.4142 14.5858C17.1953 15.3668 17.1953 16.6332 16.4142 17.4142C15.6332 18.1953 14.3668 18.1953 13.5858 17.4142C12.8047 16.6332 12.8047 15.3668 13.5858 14.5858Z",
    fill: "#79632A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.cabca8e08b481007452b13b91b82915f.svg";
export { ForwardRef as ReactComponent };